<template>
  <b-container>
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-indocyber.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            DOCUMENT PLN
          </h1>
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
          </h4>
        </CCol>
      </CRow>
      <div class="content">
        <CRow>
          <div class="col-12">
            <label class="textarea-input">Input Dokumen:</label>
            <input ref="fileupload" class="mb-2 sm-input" type="file" accept="application/pdf" @change="onChooseFile">
            <b-form inline class="form-options mb-4">
              <label for="doc-type" class="mr-2">Document Type: </label>
              <b-form-select v-model="docType">
                STD, RKS, PERDIR, KEB, TANAH
                <b-form-select-option value="STD">STD</b-form-select-option>
                <b-form-select-option value="RKS">RKS</b-form-select-option>
                <b-form-select-option value="PERDIR">PERDIR</b-form-select-option>
                <b-form-select-option value="KEB">KEB</b-form-select-option>
                <b-form-select-option value="TANAH">TANAH</b-form-select-option>
              </b-form-select>
            </b-form>
          </div>
          <CCol col="12" class="form-button">
            <div class="sm-nav-wrapper">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickSubmit" class="btn">
                  <span><img src=""></span>Submit
                </router-link>
              </div>
            </div>
          </CCol>
        </CRow>
      </div>
      <CRow v-if="keywords.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            RESPONSE DATA
          </h4>
        </CCol>
      </CRow>
      <div v-if="responseJson != null" class="content">
        <textarea class="my-2" style="width: 80%; height: 400px" disabled>{{responseJson}}</textarea>
        <hr>
      </div>
      <div v-if="keywords.length > 0" class="content">
        <CRow>
          <div class="col-12">
            <b-table small
              :fields="fields"
              :items="keywords"
            >
              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>
            </b-table>
            <hr>
          </div>
        </CRow>
      </div>
      <div v-if="tables.length > 0" class="content">
        <CRow v-for="(item, index) in tables">
          <CCol xm="12" class="justify-content-center">
            <p class="greetings-underline" style="margin-bottom: 0px">
              {{item.name}}
            </p>
          </CCol>
          <div class="col-12">
            <b-table small
              style="width: 100%"
              :fields="item.fields"
              :items="item.values"
            >
              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>
            </b-table>
            <hr>
          </div>
        </CRow>
      </div>
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      isLoading: false,
      showErrorModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      inputText: "",
      fields: [
          { key: 'label', label: 'Label' },
          { key: 'value', label: 'Value' },
      ],
      keywords: [],
      tables: [],
      categoryMap: [],
      base64: "",
      fileUpload: null,
      fiduciaData: null,
      fileName: null,
      docType: "",
      responseJson: null,
    }
  },
  methods: {
    onChooseFile(e){
      this.keywords = []
      var file = e.target.files[0]
      if(file){
        this.fileName = file.name
        this.fileUpload = file
        this.createBase64Image(file)
      }
    },
    createBase64Image(FileObject) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.base64 = reader.result.split(",")[1];
      }
      reader.readAsDataURL(FileObject);
    },
    onClickSubmit(){
      this.isLoading = true
      let processUrl = "https://core.pln-demo.inergi.id/analyze_pdf"
      let data = {
        "file": this.base64,
        "filename": this.fileName,
        "template_name": this.docType
      }
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){

          if(!response.data.success){
            this.errorLabel = response.data.message
            this.errorReload = false
            this.showErrorModal = true
            return
          }

          if(response.data.data.tables.length == 0 && response.data.data.texts.length == 0){
            this.errorLabel = "Data tidak ditemukan"
            this.errorReload = false
            this.showErrorModal = true
          }

          let raw = response.data.data
          this.responseJson = raw

          let entries = []
          for(let i = 0; i < raw.texts.length; i++){
            // entries.push({label: raw.texts[i].field_name, value: raw.texts[i].values, confidence: raw.texts[i].confidence})
            entries.push({label: raw.texts[i].field_name, value: raw.texts[i].values})
          }
          this.keywords = entries

          let tables = []
          for(let i = 0; i < raw.tables.length; i++){
            let tableFields = []
            for(let j = 0; j < raw.tables[i].columns.length; j++){
              tableFields.push({key: raw.tables[i].columns[j], label: raw.tables[i].columns[j]})
            }

            let tableValues = []

            for(let k = 0; k < raw.tables[i].values.length; k++){
              data = {}
              for(let l = 0; l < raw.tables[i].values[k].length; l++){
                data[raw.tables[i].columns[l]] = raw.tables[i].values[k][l]
              }
              tableValues.push(data)
            }

            tables.push({fields: tableFields, values: tableValues, name:raw.tables[i].name})
          }
          this.tables = tables
        }
        else {
          this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.errorReload = false
          this.showErrorModal = true
          return
        }
      })
      .catch(error => {
        if(error.response) this.errorLabel = error.response.data.reason
        else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.errorReload = false
        this.showErrorModal = true
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  },
  async mounted(){
  }
}
</script>